import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";
import Carousel from "../MentorDashboard/Carousel/Carousel";
import UpcomingSessions from "../MentorDashboard/UpcomingSessions";
import FeedbackSummary from "../MentorDashboard/FeedbackSummary";
import debounce from "lodash.debounce";
import update from "immutability-helper";
import { API } from "../../Services/api-services";
import { useHistory } from "react-router-dom";
import { encrypt } from "../../utils/others";
import { auth } from "../../utils/auth";
import Axios from "axios";
import { Spinner } from "react-bootstrap";
import BarGraph from "../MentorDashboard/BarGraph";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Frame766 from "../../assets/images/Frame766.png";
import Frame767 from "../../assets/images/Frame767.png";
import Frame773 from "../../assets/images/Frame773.png";
import Frame774 from "../../assets/images/Frame774.png";
import penalized from "../../assets/images/penalized.svg";
import { MentorSessionsAndEarnings } from "../MentorDashboard/MentorSessionsAndEarnings";
import { Typography } from "@material-ui/core";
import Notification from "./notification";
import AddSchedule from "./AddSchedule";
import "./dashboard.css";
import SlotActionModel from "../MentorDashboard/SlotActionModel";

const BASE_URL = process.env.REACT_APP_EPICENTERAPI_BASE_URL;

const useStyles = makeStyles({
  container: {
    width: "100%",
    height: "calc(100vh - 80px)",
    overflow: "auto",
  },
  mentorProfileDetails: {
    boxSizing: "border-box",
    position: "relative",
    // height: "fit-content",
    background: "#FFFDFA",
    border: "1px solid #FDECD9",
    boxShadow: "0px 1px 2px #FBE2C6",
    borderRadius: "8px",
    display: "flex",
    alignContent: "center",
    flexDirection: "column",
  },
  spinnerDiv: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  mentorEarning: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  earningsTitle: {
    color: "#7A7A7A",
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "Roboto",
  },
  earningsNumber: {
    color: "#3D3D3D",
    fontSize: "20px",
    fontWeight: "600",
  },

  sessionDemoEarnings: {
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
    width: "36%",
    alignItems: "center",
    marginTop: "20px",
    marginBottom: "16px",
  },
  count: {
    minWidth: "148px",
    height: "38px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "18px",
    textAlign: "center",
    color: "#3D3D3D",
  },
  data: {
    width: "100px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "14px",
    textAlign: "center",
    color: "#7A7A7A",
  },
  addSchedule: {
    borderRadius: "4px",
    background: "#FF712D",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    color: "#fff",
    padding: "0px 70px",
    marginTop: "24px",
  },
  addSlot: {
    borderRadius: "4px",
    background: "#FF712D",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    color: "#fff",
    padding: "0px 86px",
    marginTop: "24px",
  },
  addScheduleText: {
    fontWeight: "600",
    marginLeft: "-5px",
  },
  autoAddSlotBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "max-content",
    height: "max-content",
    marginTop: "28px",
  },
  autoAddSlotTxt: {
    display: "flex",
    alignItems: "center",
  },
  addSlotCommonCss: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  editBtn: {
    textTransform: "none",
    color: "#7A7A7A",
    cursor: "pointer",
    fontSize: "14px",
  },
});

const MobileDashboard = ({
  reportData,
  banners,
  totalSessions,
  totalPay,
  isAutoAddSlotActive,
  autoAddSlotPayload,
  setAutoAddSlotPayload,
  userId,
  blackListed,
  weekOff,
  workShift,
  rbtCount,
  slotsCount,
  showMentorLeaveModal,
  setAddSlot,
  setOpenDeleteModal,
  demoConversionCount,
}) => {
  const classes = useStyles();
  const emailRef = useRef();
  const passwordRef = useRef();
  const logoRef = useRef(null);
  const history = useHistory();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [banner, setBanner] = useState([]);
  const [payoutData, setPayoutData] = useState([]);
  const [yourEarnings, setYourEarnings] = useState([]);
  const [pendingNotifications, setPendingNotifications] = useState(0);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [demos, setDemos] = useState(false);

  const autoAddChangeHandler = () => {
    if (isAutoAddSlotActive === 0) {
      const editProps = {
        autoAddSlotPayload: autoAddSlotPayload,
        setAutoAddSlotPayload: setAutoAddSlotPayload,
        type: "Add",
        userId: userId,
      };
      localStorage.setItem("editProps", JSON.stringify(editProps));
      history.push({
        pathname: `/add-slot`,
        state: { editProps },
      });
    } else {
      const editProps = {
        autoAddSlotPayload: autoAddSlotPayload,
        setAutoAddSlotPayload: setAutoAddSlotPayload,
        type: "Add",
        userId: userId,
      };
      localStorage.setItem("editProps", JSON.stringify(editProps));
      history.push({
        pathname: `/disable-slot`,
        state: { editProps },
      });
    }
  };
  const AntSwitch = withStyles((theme) => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: "flex",
    },
    switchBase: {
      padding: 2,
      color: "white",
      borderColor: "none",
      "&$checked": {
        transform: "translateX(12px)",
        color: "#FF702D",
        "& + $track": {
          opacity: 1,
          backgroundColor: "#ffdbc9",
          borderColor: "none",
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: "none",
    },
    track: {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "#ffdbc9",
    },
    checked: {},
  }))(Switch);

  const AutoAddSlotSwitch = withStyles((theme) => ({
    root: {
      width: 34,
      height: 17,
      padding: 0,
      display: "flex",
      marginLeft: "24%",
    },
    switchBase: {
      padding: 0.8,
      color: "#FFEBE0",
      borderColor: "none",
      "&$checked": {
        transform: "translateX(16px)",
        color: "#FF702D",
        "& + $track": {
          opacity: 1,
          backgroundColor: "#ffdbc9",
          borderColor: "none",
        },
      },
    },
    thumb: {
      width: 16,
      height: 16,
      boxShadow: "none",
    },
    track: {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "#c5d3e5",
    },
    checked: {},
  }))(Switch);

  const handleAddSchedule = () => {
    if (rbtCount == 0) {
      history.push(`/add-schedule`);
    } else {
      setOpenDeleteModal(true);
    }
  };

  const handleAddSlot = () => {
    const editProps = {
      autoAddSlotPayload: autoAddSlotPayload,
      setAutoAddSlotPayload: setAutoAddSlotPayload,
      type: "Edit",
      userId: userId,
    };
    localStorage.setItem("editProps", JSON.stringify(editProps));
    history.push({
      pathname: `/add-slot`,
      state: { editProps },
    });
  };
  const getNotificationNumbers = (notifications) => {
    if (
      Object.keys(notifications).length > 0 &&
      notifications.hasOwnProperty("pendingToday")
    ) {
      setPendingNotifications(notifications.pendingToday);
    }
  };
  return (
    <>
      <Notification />
      <div className={classes.container}>
        <Grid container sm={12}>
          <Grid item xs={11} style={{ margin: "24px auto" }}>
            {banners.length > 0 ? (
              <div className={classes.mentorProfileDetails}>
                <Carousel banners={banners} />
              </div>
            ) : (
              <div className={classes.spinnerDiv}>
                <Spinner
                  animation="border"
                  variant="secondary"
                  className="my-3"
                />
              </div>
            )}
          </Grid>
          <Grid
            item
            xs={11}
            style={{
              margin: "24px auto",
              borderRadius: "8px",
              border: "1px solid #FDECD9",
              boxShadow: "0px 1px 2px 0px #FBE2C6",
              background: "#FFFDFA",
            }}
          >
            <Grid container style={{ padding: "16px" }}>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div className={classes.earningsTitle}>Your earnings</div>
                <div className={classes.earningsNumber}>
                  {" "}
                  ₹{totalPay ? totalPay : 0}{" "}
                </div>
              </Grid>
              <Grid item xs={12} className={classes.mentorEarning}>
                <div className={classes.sessionDemoEarnings}>
                  <img src={Frame766} width="28px" height="28px" />
                  <Typography className={classes.count}>
                    {totalSessions ? totalSessions : "-"}
                  </Typography>
                  <Typography className={classes.data}>
                    TOTAL SESSIONS
                  </Typography>
                </div>
                <div className={classes.sessionDemoEarnings}>
                  <img src={Frame767} width="28px" height="28px" />
                  <Typography className={classes.count}>
                    {demoConversionCount || "-"}
                  </Typography>
                  <Typography className={classes.data}>
                    DEMO CONVERSIONS
                  </Typography>
                </div>
                <div className={classes.sessionDemoEarnings}>
                  <img src={penalized} width="28px" height="28px" />
                  <Typography className={classes.count}>
                    {reportData?.totalPenalisedClasses
                      ? reportData?.totalPenalisedClasses
                      : "-"}
                  </Typography>
                  <Typography className={classes.data}>
                    PENALIZED CLASSES
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={11}
            style={{
              margin: "24px auto",
              borderRadius: "8px",
              border: "1px solid #FDECD9",
              boxShadow: "0px 1px 2px 0px #FBE2C6",
              background: "#FFFDFA",
            }}
          >
            <SlotActionModel
              setAddSlot={setAddSlot}
              showMentorLeaveModal={showMentorLeaveModal}
              isAutoAddSlotActive={isAutoAddSlotActive}
              autoAddSlotChangeHandler={autoAddChangeHandler}
              handleOpenModal={handleAddSlot}
              autoAddSlotPayload={autoAddSlotPayload}
              slotsCount={slotsCount}
              rbtCount={rbtCount}
              blackListed={blackListed}
              handleScheduleAction={handleAddSchedule}
              weekOff={weekOff}
              workShift={workShift}
            />
          </Grid>
          <Grid
            item
            xs={11}
            style={{
              margin: "24px auto",
              borderRadius: "8px",
              border: "1px solid #FDECD9",
              boxShadow: "0px 1px 2px 0px #FBE2C6",
              background: "#FFFDFA",
            }}
          >
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "space-around" }}
            >
              <Grid item xs={5}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid
                    container
                    justifyContent="space-around"
                    style={{ marginBottom: "15px" }}
                  >
                    <KeyboardDatePicker
                      autoOk={true}
                      classes={{
                        root: classes.datePickerController,
                      }}
                      variant="inline"
                      format="dd-MM-yyyy"
                      margin="normal"
                      value={selectedDate}
                      onChange={(date) => {
                        setSelectedDate(date);
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid
                item
                xs={5}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Grid item className={classes.barGraphTxt}>
                  Classes
                </Grid>
                <Grid
                  item
                  xs={5}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <AntSwitch
                    checked={demos}
                    onChange={() => {
                      setDemos((demo) => !demo);
                    }}
                  />
                </Grid>
                <Grid item className={classes.barGraphTxt}>
                  Demos
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <BarGraph
                type={demos ? "demos" : "classes"}
                date={selectedDate}
              />
            </Grid>
          </Grid>
          <Grid item xs={11} style={{ margin: "24px auto" }}>
            <UpcomingSessions />
          </Grid>
          <Grid item xs={11} style={{ margin: "24px auto" }}>
            <FeedbackSummary
              title="FEEDBACK SUMMARY FOR TODAY"
              layout="dashboard"
              getNotificationNumbers={getNotificationNumbers}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default MobileDashboard;
